import { useEffect, useState } from 'react';
import { aiApi } from '../../api/ai.js';

/** Флаг «ИИ аналитик доступен» для меню и плиток. Это слой представления: сервер сам отвечает
 *  403 тем, кого нет в списке. Ошибка запроса — раздел просто не показывается. */
export function useAiAccess(role: string | null): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!role || role === 'client') { setEnabled(false); return undefined; }
    let alive = true;
    aiApi.access()
      .then((r) => { if (alive) setEnabled(r.enabled); })
      .catch(() => { if (alive) setEnabled(false); });
    return () => { alive = false; };
  }, [role]);
  return enabled;
}
